/**
 *
 * Asynchronously loads the component for SuperAdminDashboard
 *
 */

import { lazyLoad } from "utils/loadable"

export const SuperAdminDashboard = lazyLoad(
  () => import("./index"),
  module => module.SuperAdminDashboard,
)
